module.exports = __webpack_public_path__ + "assets/img/dana_houser.0b59b553.jpg";